import Axios from "axios";
import { IGetCustomerInfoResponse } from "../models/customer.model";
import { ApiResultModel } from "../models/common.model";
import { APIBASE_URL, CUSTOMER_INFO } from "../config/cacheKey";

export const GetCustomerInfo = async (

): Promise<IGetCustomerInfoResponse> => {
    return await Axios.post<ApiResultModel<IGetCustomerInfoResponse>>(
        APIBASE_URL + CUSTOMER_INFO + "/GetCustomerInfo",
    ).then((result) => {
        return result.data.data;
    });
};
